export default __webpack_public_path__ + "static/media/WorkSans-Bold.00d0a8f9.woff2";